module.exports = __webpack_public_path__ + "img/tb-5.2a514de2.jpg";